export const NEWSLETTER_ADMIN_LIST_REQUEST =
  "NEWSLETTER_ADMIN_LIST_REQUEST";
export const NEWSLETTER_ADMIN_LIST_SUCCESS =
  "NEWSLETTER_ADMIN_LIST_SUCCESS";
export const NEWSLETTER_ADMIN_LIST_FAIL = "NEWSLETTER_ADMIN_LIST_FAIL";

export const NEWSLETTER_SEND_REQUEST = "NEWSLETTER_SEND_REQUEST";
export const NEWSLETTER_SEND_SUCCESS = "NEWSLETTER_SEND_SUCCESS";
export const NEWSLETTER_SEND_FAIL = "NEWSLETTER_SEND_FAIL";
export const NEWSLETTER_SEND_RESET = "NEWSLETTER_SEND_RESET";
